import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Selector from 'components/Selector'
import Item from './Item'
import {fetchLinkedOptions} from 'modules/linkedfield/actions'
import {
    setFilters
} from 'modules/collection/actions'
import {fieldtype} from 'utils/enums/fieldtype'
import {rules, logicalValues} from 'utils/enums/filters'
import {formulaTypes} from 'utils/enums/formula'
import {getFilteringCandidtes} from 'utils/utils'

const FilterList = styled.div`
    margin-bottom: 20px;
`

const Empty = styled.div`
    height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: #FFF;
`

class FilterDialogContent extends React.Component {
    constructor(props) {
        super(props)

		this.filteringCandidtes = getFilteringCandidtes(props.entity)
        this.filterFields = this.filteringCandidtes.map(item => {
			return {
				name: item.id,
				title: item.name,
				type: item.field.uiType,
				formulaType: item.field.uiType === fieldtype.formula ?
					item.field.uiConfig.type === formulaTypes.renewal.code ?
						item.field.uiConfig.formula.showPeriod ? formulaTypes.datetime.code :
							formulaTypes.renewal.code : item.field.uiConfig.type : undefined,
				config: item.field.uiType === fieldtype.formula ? item.field.uiConfig.format : item.field.uiConfig,
				foreignerEcn: item.field.uiType === fieldtype.linkedfield ? item.field.foreignerEcn : undefined,
				linkedRelation: item.field.uiType === fieldtype.linkedfield && item.field.linkedRelation.length ?
					item.field.linkedRelation[0] : undefined
			}
		})

        this.state = {
            filters: [],
            errors: [],
            save: false
        }
    }

    componentDidMount() {
        const filters = []

        this.props.collectionState.filters.forEach(item => {
            const filter = {...item}
            
            if (item.fieldType === fieldtype.linkedfield) {
				const fieldId = item.pathId.slice(-1)[0]
				filter.fieldId = fieldId
				this.props.fetchLinkedOptions(fieldId)
			}

			filters.push(filter)
        })

        this.setState({ filters })
    }

    handleSelect = (data) => {
        const filters = [...this.state.filters]
		const fieldId = Number(data.id.split(',').slice(-1)[0])
        if (data.type === fieldtype.linkedfield) this.props.fetchLinkedOptions(fieldId)
        filters.push({
            id: data.id,
			fieldId,
            fieldType: data.type,
            rule: Object.values(rules[data.type])[0].code,
            valueMin: data.type === fieldtype.check ? logicalValues.indeterminate.code : null,
            valueMax: null
        })
        this.setState({ filters })
    }

    changeRule = (e) => {
        const filters = [...this.state.filters]
        const el = {...filters.find(item => item.id === e.target.name)}
        const index = filters.findIndex(item => item.id === e.target.name)

        el.rule = e.target.value

        const conditions = rules[el.fieldType]

        if ((conditions.empty &&  e.target.value === conditions.empty.code) ||
        (conditions.notEmpty &&  e.target.value === conditions.notEmpty.code) ||
        (conditions.noValue &&  e.target.value === conditions.noValue.code) ||
        (conditions.anyValue &&  e.target.value === conditions.anyValue.code) ||
        (conditions.invalid && e.target.value === conditions.invalid.code)) {
            el.valueMin = null
            el.valueMax = null
        }

        if (conditions.between &&  e.target.value !== conditions.between.code) {
            el.valueMax = null
        }

        filters.splice(index, 1, el)

        this.setState({ filters })
    }

    changeValue = (value, type, name) => {
        const filters = [...this.state.filters]
        const filter = {...filters.find(item => item.id === name)}
        const index = filters.findIndex(item => item.id === name)

        if (type === 'max') {
            filter.valueMax = value
        } else {
            filter.valueMin = value
        }

        filters.splice(index, 1, filter)
        this.setState({ filters })
    }

    deleteRule = (name) => {
        const filters = [...this.state.filters]
        const errors = [...this.state.errors]
        const newFilters = filters.filter(item => item.id !== name)
        const newErrors = errors.filter(item => item.id !== name)
        this.setState({ filters: [...newFilters], errors: [...newErrors] })
    }

    clearFilters = () => {
        this.setState({
            filters: [],
            errors: []
        }, () => {
            this.props.setFilters(this.state.filters, this.state.save)
            this.props.onClose()
        })
    }

    setFilters = () => {
        const errors = this.state.filters.filter(item => {
            const conditions = rules[item.fieldType]
			const field = this.filteringCandidtes.find(obj => obj.id === item.id)
            const valueMin = item.fieldType === fieldtype.linkedfield && item.valueMin ?
                item.valueMin.filter(value => this.props.linkedOptions[item.fieldId] && this.props.linkedOptions[item.fieldId].find(el => el.id === value)) : []
            const formulaType = item.fieldType === fieldtype.formula ?
                field.field.uiConfig.type === formulaTypes.renewal.code ?
                    field.field.uiConfig.formula.showPeriod ? formulaTypes.datetime.code :
                        formulaTypes.renewal.code : field.field.uiConfig.type : undefined

                return (item.fieldType === fieldtype.number && item.rule === conditions.between.code && !item.valueMax) ||
                (item.fieldType === fieldtype.number && item.rule !== conditions.noValue.code && !item.valueMin && item.valueMin !== 0) ||
                (item.fieldType === fieldtype.formula && formulaType === formulaTypes.number.code && item.rule !== conditions.invalid.code && !item.valueMin) ||
                (item.fieldType === fieldtype.formula && formulaType === formulaTypes.number.code && item.rule === conditions.between.code && !item.valueMax) ||
                (item.fieldType === fieldtype.formula && formulaType === formulaTypes.datetime.code && item.rule !== conditions.invalid.code && (!item.valueMin || !item.valueMin.offset || !item.valueMin.period)) ||
                (item.fieldType === fieldtype.formula && formulaType === formulaTypes.datetime.code && item.rule === conditions.between.code && (!item.valueMax || !item.valueMax.offset || !item.valueMax.period)) ||
                (item.fieldType === fieldtype.formula && formulaType === formulaTypes.renewal.code && item.rule !== conditions.invalid.code && (!item.valueMin || !item.valueMin.value || item.valueMin.value.offset === null)) ||
                (item.fieldType === fieldtype.formula && formulaType === formulaTypes.renewal.code && item.rule === conditions.between.code && (!item.valueMax || !item.valueMax.value || item.valueMax.value.offset === null)) ||
                ((item.fieldType === fieldtype.text || item.fieldType === fieldtype.textarea || item.fieldType === fieldtype.email) &&  item.rule !== conditions.empty.code && item.rule !== conditions.notEmpty.code && !item.valueMin) ||
                (item.fieldType === fieldtype.linkedfield && item.rule === conditions.is.code && !valueMin.length) ||
                (item.fieldType === fieldtype.datetime && item.rule !== conditions.noValue.code && (!item.valueMin || !item.valueMin.value || item.valueMin.value.offset === null)) ||
                (item.fieldType === fieldtype.datetime && item.rule === conditions.between.code && (!item.valueMax || !item.valueMax.value || item.valueMax.value.offset === null))
        })

        if (errors.length) {
            this.setState({ errors: [...errors] })
        } else {
            const filters = this.state.filters.map(item => {
                const field = this.filteringCandidtes.find(obj => obj.id === item.id)
                const formulaType = item.fieldType === fieldtype.formula ?
                    field.field.uiConfig.type === formulaTypes.renewal.code ?
                        field.field.uiConfig.formula.showPeriod ? formulaTypes.datetime.code :
                            formulaTypes.renewal.code : field.field.uiConfig.type : undefined

                return {
                    pathId: item.id.split(',').map(item => Number(item)),
                    fieldType: item.fieldType,
                    rule: item.rule,
                    valueMin: formulaType === formulaTypes.datetime.code && item.rule === rules.formula.between.code ? {
                        offset: item.valueMin.offset,
                        period: item.valueMax.period
                    } : item.valueMin,
                    valueMax: item.valueMax
                }
            })

            this.props.setFilters(filters, this.state.save)
            this.props.onClose()
        }
    }

    render() {
        const { intl } = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "filter.title"})}
                </DialogTitle>
                <DialogContent>
                    <FilterList>
                    {!this.state.filters.length &&
                        <Empty>{intl.formatMessage({id: "filter.empty"})}</Empty>
                    }
                    {this.state.filters.map((filter, index) => {
						const field = this.filterFields.find(col => col.name === filter.id)
						return <Item
							error={!!this.state.errors.find(error => error.id === filter.id)}
							valueMin={filter.valueMin}
							valueMax={filter.valueMax}
							config={field.config}
							key={index}
							type={filter.fieldType}
							formulaType={field.formulaType}
							title={field.title}
							name={filter.id}
							changeRule={this.changeRule}
							rule={filter.rule}
							changeValue={this.changeValue}
							linkedOptions={this.props.linkedOptions[filter.fieldId] ? this.props.linkedOptions[filter.fieldId] : []}
							deleteRule={this.deleteRule}
						/>
					})}
                    </FilterList>
                    {this.props.permissions.Designer && !this.props.globalView &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.save}
                                    onChange={(e) => this.setState({ save: e.target.checked })}
                                />
                            }
                            style={{width: '100%', marginBottom: '20px'}}
                            label={intl.formatMessage({id: "filter.save_to_view"})}
                        />
                    }
                    <Selector
                        data={this.filterFields.filter(field =>
                            !this.state.filters.find(filter => filter.id === field.name)).map(item => {
                                return {
                                    name: item.title,
                                    id: item.name,
                                    type: item.type
                                }
                            }
                        )}
                        disabled={this.state.filters.length === this.filterFields.length}
                        handleSelect={this.handleSelect}
                        text='filter.add'
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button onClick={this.clearFilters} color="secondary" variant="contained">
                        {intl.formatMessage({id: "filter.clear"})}
                    </Button>
                    <Button onClick={this.setFilters} color="primary" variant="contained">
                        {intl.formatMessage({id: "filter.apply"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({login, entities, linkedfield, collection}) => ({
    permissions: login.permissions,
    entities: entities.entities,
    entity: collection.entityId,
    linkedOptions: linkedfield.linkedOptions,
    collectionState: collection.collectionState
})

export default connect(mapStateToProps, {fetchLinkedOptions, setFilters})(injectIntl(FilterDialogContent))
